__turbopack_context__.v({
  "canvas": "_8ZHrnq_canvas",
  "ready": "_8ZHrnq_ready",
});
